import toolkit from '@/app/mixins/toolkit/item';
import pensions from '@/app/mixins/toolkit/pension/pension';
import FundInformation from '@/app/modules/fund/components/fund-information/fund-information.vue';
import ReviewItem from '@/app/modules/toolkit/common/components/review-item/review-item.vue';
import ConfirmModal from '@/app/modules/toolkit/common/components/confirm-modal/confirm-modal.vue';
import PensionReviewPensionDetails from './pension-review-pension-details/pension-review-pension-details.vue';
import PdfContainer from '@/app/modules/pdf/containers/pdf-container.vue';
import { getAgeAtSpecificDate, getPreservationAge } from '@/app/utils/utils';
import { types } from '@/app/filters/filters';

export default {
  name: 'pension-review',
  mixins: [toolkit, pensions],
  components: {
    FundInformation,
    ReviewItem,
    ConfirmModal,
    PensionReviewPensionDetails,
    PdfContainer,
  },
  data: () => ({
    loadingComplete: false,
    loadingExit: false,
    showConfirmModal: false,
  }),
  computed: {
    canEdit() {
      const canEditFund = this.$store.getters['fund/canEditActiveFund'] || false;
      const appPermissions = this.$store.getters['account/getAppPermissions'] || [];
      const toolkitAppPermission = appPermissions.filter(app => app.appName === 'TOOLKIT')[0];
      return toolkitAppPermission.permission === 'OWNER' && canEditFund;
    },
    isComplete() {
      return this.$store.getters['toolkit/getItem'].status === 'COMPLETE';
    },
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    item() {
      return this.$store.getters['toolkit/getItem'];
    },
    setup() {
      return this.getItem.setup;
    },
    pensionMember() {
      return this.getItem.requirements.member;
    },
    ageAtCommencement() {
      return getAgeAtSpecificDate(
        new Date(this.pensionMember.dateOfBirth),
        new Date(this.getItem.requirements.startDate),
      );
    },
    preservationAge() {
      return getPreservationAge(new Date(this.pensionMember.dateOfBirth));
    },
    releaseCondition() {
      const { reasons, otherReason } = this.getItem.requirements.eligibility;
      if (reasons === 'other') {
        return `I am eligible to convert this amount to a pension because ${otherReason}`;
      }
      if (reasons === '') {
        return 'Pensioner is over 65';
      }
      return reasons;
    },
  },
  methods: {
    saveItem(complete) {
      return this.$store.dispatch('toolkit/saveItem', complete);
    },
    handleSaveAndNew() {
      this.loadingComplete = true;
      this.showConfirmModal = false;
      this.saveItem(true)
        .then(() => {
          this.$mixpanel.track('Toolkit Item', {
            uuid: this.item.uuid,
            action: 'Completed',
            status: types(this.item.status),
            type: this.item.type,
          });

          if (this.canEdit) {
            this.$router.push('/toolkit/pension/establishment');
          } else {
            this.$router.push('/');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSaveAndExit() {
      this.loadingExit = true;
      this.$mixpanel.track('Toolkit Item', {
        uuid: this.item.uuid,
        action: 'Exit',
        status: types(this.item.status),
        type: this.item.type,
      });
      if (this.canEdit) {
        this.$router.push('/toolkit/pension/establishment');
      } else {
        this.$router.push('/');
      }
    },
  },
};
